//艾知星
$(".azx-introduce-icon-wx").hover(function(){
    $(this).find(".icon-pic").attr('src',"/static/images/decorator/connect-icon1-hover.png"); 	
    $(this).find("div").show();
}, function(){
	$(this).find(".icon-pic").attr('src',"/static/images/decorator/connect-icon1-white.png"); 	 	
	$(this).find("div").hide();
});

$(".azx-introduce-icon-tp").hover(function(){
    $(this).find(".icon-pic").attr('src',"/static/images/decorator/connect-icon3-hover.png"); 	
    $(this).find("div").show();
}, function(){
	$(this).find(".icon-pic").attr('src',"/static/images/decorator/connect-icon3-white.png"); 	 	
	$(this).find("div").hide();
});